/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import triggerToast from "./notifications";

const handleFuryApiError = (err) => {
  if (err && err.response && err.response.data &&
    err.response.data.errorCode) {
    const {errorCode} = err.response.data;
    const errorMessage = err.response.data?.message || "Something went wrong. Please try again";

    switch (errorCode) {
      case "AUTH021":
        triggerToast("Wrong OTP Entered!");
        break;
      case "INVCAP00":
        triggerToast("Invalid Captcha!");
        break;
      case "AUTH008":
        triggerToast("Wrong Pin Entered!");
        break;
      case "PREV_REQ_PENDING":
        triggerToast("Try again after some time!");
        break;
      default:
        triggerToast(errorMessage);
    }
  } else {
    triggerToast("Something went wrong. Please try again");
  }
};

export default handleFuryApiError;
